export enum UserType {
  SUPER_ADMIN = 'super-admin',
  ADMIN = 'admin',
  FINANCE = 'finance',
  SUPERVISOR = 'supervisor',
  SUPPORT = 'support',
  ATTENDANT = 'attendant',
}

export const isUserType = (userType: string, type: UserType): boolean => userType === type
